import { AllergenIntolerance, DietaryPattern, Diseases, EducationLevel, FamilyMember, Habit, InsuranceCompany, Occupations, PregnancyStage } from 'src/types/consulting';
export var educationOptions = [{
  label: '不識字',
  value: EducationLevel.Illiterate,
  i18nKey: 'client:educationOptions.illiterate'
}, {
  label: '小學以下',
  value: EducationLevel.PrimarySchoolBelow,
  i18nKey: 'client:educationOptions.primarySchoolBelow'
}, {
  label: '國中',
  value: EducationLevel.JuniorHighSchool,
  i18nKey: 'client:educationOptions.juniorHighSchool'
}, {
  label: '高中',
  value: EducationLevel.HighSchool,
  i18nKey: 'client:educationOptions.highSchool'
}, {
  label: '專科或大學',
  value: EducationLevel.CollegeOrUniversity,
  i18nKey: 'client:educationOptions.collegeOrUniversity'
}, {
  label: '研究所以上',
  value: EducationLevel.GraduateSchoolOrAbove,
  i18nKey: 'client:educationOptions.graduateSchoolOrAbove'
}];
export var occupationsOptions = [{
  label: '軍',
  value: Occupations.Military,
  i18nKey: 'client:occupationsOptions.military'
}, {
  label: '公',
  value: Occupations.Government,
  i18nKey: 'client:occupationsOptions.government'
}, {
  label: '教',
  value: Occupations.Education,
  i18nKey: 'client:occupationsOptions.education'
}, {
  label: '工',
  value: Occupations.Industry,
  i18nKey: 'client:occupationsOptions.industry'
}, {
  label: '商',
  value: Occupations.Business,
  i18nKey: 'client:occupationsOptions.business'
}, {
  label: '自由業',
  value: Occupations.Freelancer,
  i18nKey: 'client:occupationsOptions.freelancer'
}, {
  label: '家管',
  value: Occupations.Household,
  i18nKey: 'client:occupationsOptions.household'
}, {
  label: '其他',
  value: Occupations.Others,
  i18nKey: 'client:occupationsOptions.others'
}];
export var nutritionGoodOptions = [{
  label: '低熱量',
  value: 'lowCalories',
  i18nKey: 'client:nutritionGoodOptions.lowCalories'
}, {
  label: '低脂肪',
  value: 'lowFat',
  i18nKey: 'client:nutritionGoodOptions.lowFat'
}, {
  label: '低鈉',
  value: 'lowSodium',
  i18nKey: 'client:nutritionGoodOptions.lowSodium'
}, {
  label: '低糖份',
  value: 'lowSugar',
  i18nKey: 'client:nutritionGoodOptions.lowSugar'
}, {
  label: '纖維值足夠',
  value: 'sufficientFiber',
  i18nKey: 'client:nutritionGoodOptions.sufficientFiber'
}, {
  label: '健康餐點',
  value: 'healthyMeal',
  i18nKey: 'client:nutritionGoodOptions.healthyMeal'
}];
export var nutritionBadOptions = [{
  label: '高熱量',
  value: 'highCalories',
  i18nKey: 'client:nutritionBadOptions.highCalories'
}, {
  label: '高脂肪',
  value: 'highFat',
  i18nKey: 'client:nutritionBadOptions.highFat'
}, {
  label: '高鈉',
  value: 'highSodium',
  i18nKey: 'client:nutritionBadOptions.highSodium'
}, {
  label: '高糖份',
  value: 'highSugar',
  i18nKey: 'client:nutritionBadOptions.highSugar'
}, {
  label: '纖維值不足',
  value: 'insufficientFiber',
  i18nKey: 'client:nutritionBadOptions.insufficientFiber'
}, {
  label: '不健康餐點',
  value: 'unhealthyMeal',
  i18nKey: 'client:nutritionBadOptions.unhealthyMeal'
}];
export var insuranceOptions = [{
  label: '臺銀人壽保險股份有限公司',
  value: InsuranceCompany.TaiwanBankLife,
  i18nKey: 'client:insurance.taiwanBankLife'
}, {
  label: '台灣人壽保險股份有限公司',
  value: InsuranceCompany.TaiwanLife,
  i18nKey: 'client:insurance.taiwanLife'
}, {
  label: '保誠人壽保險股份有限公司',
  value: InsuranceCompany.PrudentialLife,
  i18nKey: 'client:insurance.prudentialLife'
}, {
  label: '國泰人壽保險股份有限公司',
  value: InsuranceCompany.CathayLife,
  i18nKey: 'client:insurance.cathayLife'
}, {
  label: '中國人壽保險股份有限公司',
  value: InsuranceCompany.ChinaLife,
  i18nKey: 'client:insurance.chinaLife'
}, {
  label: '南山人壽保險股份有限公司',
  value: InsuranceCompany.NanshanLife,
  i18nKey: 'client:insurance.nanshanLife'
}, {
  label: '新光人壽保險股份有限公司',
  value: InsuranceCompany.ShinKongLife,
  i18nKey: 'client:insurance.shinKongLife'
}, {
  label: '富邦人壽保險股份有限公司',
  value: InsuranceCompany.FubonLife,
  i18nKey: 'client:insurance.fubonLife'
}, {
  label: '國寶人壽保險股份有限公司',
  value: InsuranceCompany.KuoBaoLife,
  i18nKey: 'client:insurance.kuoBaoLife'
}, {
  label: '三商美邦人壽保險股份有限公司',
  value: InsuranceCompany.SinoPacLife,
  i18nKey: 'client:insurance.sinoPacLife'
}, {
  label: '朝陽人壽保險股份有限公司',
  value: InsuranceCompany.ChaoYangLife,
  i18nKey: 'client:insurance.chaoYangLife'
}, {
  label: '幸福人壽保險股份有限公司',
  value: InsuranceCompany.HappinessLife,
  i18nKey: 'client:insurance.happinessLife'
}, {
  label: '遠雄人壽保險事業股份有限公司',
  value: InsuranceCompany.FarGloryLife,
  i18nKey: 'client:insurance.farGloryLife'
}, {
  label: '宏泰人壽保險股份有限公司',
  value: InsuranceCompany.HontaiLife,
  i18nKey: 'client:insurance.hontaiLife'
}, {
  label: '安聯人壽保險股份有限公司',
  value: InsuranceCompany.AllianzLife,
  i18nKey: 'client:insurance.allianzLife'
}, {
  label: '中華郵政股份有限公司 ',
  value: InsuranceCompany.PostOfficeLife,
  i18nKey: 'client:insurance.postOfficeLife'
}, {
  label: '保德信國際人壽保險股份有限公司',
  value: InsuranceCompany.PrudentialIntLife,
  i18nKey: 'client:insurance.prudentialIntLife'
}, {
  label: '全球人壽保險股份有限公司',
  value: InsuranceCompany.GlobalLife,
  i18nKey: 'client:insurance.globalLife'
}, {
  label: '元大人壽保險股份有限公司',
  value: InsuranceCompany.YuanDaLife,
  i18nKey: 'client:insurance.yuanDaLife'
}, {
  label: '中國信託人壽保險股份有限公司 ',
  value: InsuranceCompany.CTBCLife,
  i18nKey: 'client:insurance.ctbcLife'
}, {
  label: '第一金人壽保險股份有限公司',
  value: InsuranceCompany.FirstGoldLife,
  i18nKey: 'client:insurance.firstGoldLife'
}, {
  label: '合作金庫人壽保險股份有限公司',
  value: InsuranceCompany.TCBLife,
  i18nKey: 'client:insurance.tcbLife'
}, {
  label: '國際康健人壽保險股份有限公司',
  value: InsuranceCompany.InternationalHealthLife,
  i18nKey: 'client:insurance.internationalHealthLife'
}, {
  label: '英屬百慕達商友邦人壽保險股份有限公司台灣分公司',
  value: InsuranceCompany.AIALife,
  i18nKey: 'client:insurance.aiaLife'
}, {
  label: '法商法國巴黎人壽保險股份有限公司台灣分公司',
  value: InsuranceCompany.BNPPLife,
  i18nKey: 'client:insurance.bnppLife'
}, {
  label: '英屬百慕達商中泰人壽保險股份有限公司台灣分公司',
  value: InsuranceCompany.ChungTaiLife,
  i18nKey: 'client:insurance.chungTaiLife'
}, {
  label: '英屬曼島商蘇黎世國際人壽保險股份有限公司台灣分公司',
  value: InsuranceCompany.ZurichLife,
  i18nKey: 'client:insurance.zurichLife'
}];
export var dietaryPatternOptions = [{
  label: '蛋奶素',
  value: DietaryPattern.EggAndDairyVegetarian,
  i18nKey: 'client:dietaryPattern.eggAndDairyVegetarian'
}, {
  label: '蛋素',
  value: DietaryPattern.EggVegetarian,
  i18nKey: 'client:dietaryPattern.eggVegetarian'
}, {
  label: '奶素',
  value: DietaryPattern.DairyVegetarian,
  i18nKey: 'client:dietaryPattern.dairyVegetarian'
}, {
  label: '海鮮素',
  value: DietaryPattern.Pescatarian,
  i18nKey: 'client:dietaryPattern.pescetarian'
}, {
  label: '全素',
  value: DietaryPattern.Vegan,
  i18nKey: 'client:dietaryPattern.vegan'
}, {
  label: '五辛素',
  value: DietaryPattern.FiveSpicesVegan,
  i18nKey: 'client:dietaryPattern.fiveSpicesVegan'
}];
export var allergenIntoleranceOptions = [{
  label: '蠶豆',
  value: AllergenIntolerance.FavaBean,
  i18nKey: 'client:allergenIntolerance.favaBean'
}, {
  label: '蛋',
  value: AllergenIntolerance.Egg,
  i18nKey: 'client:allergenIntolerance.egg'
}, {
  label: '牛奶(乳糖不耐症)',
  value: AllergenIntolerance.MilkLactoseIntolerance,
  i18nKey: 'client:allergenIntolerance.milkLactoseIntolerance'
}, {
  label: '海鮮',
  value: AllergenIntolerance.Seafood,
  i18nKey: 'client:allergenIntolerance.seafood'
}, {
  label: '麥麩',
  value: AllergenIntolerance.Gluten,
  i18nKey: 'client:allergenIntolerance.gluten'
}, {
  label: '花生',
  value: AllergenIntolerance.Peanut,
  i18nKey: 'client:allergenIntolerance.peanut'
}, {
  label: '黃豆',
  value: AllergenIntolerance.Soy,
  i18nKey: 'client:allergenIntolerance.soy'
}];
export var habitOptions = [{
  label: '抽菸',
  value: Habit.Smoking,
  i18nKey: 'client:habit.smoking',
  comment: '',
  placeholder: '例：每天兩包',
  placeholderI18nKey: 'client:habit.smokingPlaceholder'
}, {
  label: '喝酒',
  value: Habit.Drinking,
  i18nKey: 'client:habit.drinking',
  comment: '',
  placeholder: '例：每天兩罐啤酒',
  placeholderI18nKey: 'client:habit.drinkingPlaceholder'
}, {
  label: '檳榔',
  value: Habit.Areaca,
  i18nKey: 'client:habit.betelnut',
  comment: '',
  placeholder: '例：每天兩包',
  placeholderI18nKey: 'client:habit.betelnutPlaceholder'
}];
export var diseaseOptions = [{
  label: '高血壓',
  value: Diseases.Hypertension,
  i18nKey: 'client:disease.hypertension'
}, {
  label: '高血脂',
  value: Diseases.Hyperlipidemia,
  i18nKey: 'client:disease.hyperlipidemia'
}, {
  label: '代謝症候群',
  value: Diseases.MetabolicSyndrome,
  i18nKey: 'client:disease.metabolicSyndrome'
}, {
  label: '脂肪肝',
  value: Diseases.FattyLiver,
  i18nKey: 'client:disease.fattyLiver'
}, {
  label: '糖尿病',
  value: Diseases.Diabetes,
  i18nKey: 'client:disease.diabetes'
}, {
  label: '心臟病',
  value: Diseases.HeartDisease,
  i18nKey: 'client:disease.heartDisease'
}, {
  label: '痛風',
  value: Diseases.Gout,
  i18nKey: 'client:disease.gout'
}, {
  label: '慢性腎臟病(CKD)',
  value: Diseases.CKD,
  i18nKey: 'client:disease.ckd'
}, {
  label: '腹膜透析(PD)',
  value: Diseases.PeritonealDialysis,
  i18nKey: 'client:disease.peritonealDialysis'
}, {
  label: '血液透析(HD)',
  value: Diseases.Hemodialysis,
  i18nKey: 'client:disease.hemodialysis'
}, {
  label: '膽結石',
  value: Diseases.Gallstones,
  i18nKey: 'client:disease.gallstones'
}, {
  label: '其他',
  value: Diseases.Others,
  i18nKey: 'client:disease.others',
  placeholder: '例：每天兩包',
  placeholderI18nKey: 'client:disease.othersPlaceholder'
}];
export var pregnant = [{
  label: '懷孕第一期',
  value: PregnancyStage.FirstTrimester,
  i18nKey: 'client:pregnant.pregnancyFirstTrimester'
}, {
  label: '懷孕第二期',
  value: PregnancyStage.SecondTrimester,
  i18nKey: 'client:pregnant.pregnancySecondTrimester'
}, {
  label: '懷孕第三期',
  value: PregnancyStage.ThirdTrimester,
  i18nKey: 'client:pregnant.pregnancyThirdTrimester'
}, {
  label: '哺乳期',
  value: PregnancyStage.LactationPeriod,
  i18nKey: 'client:pregnant.lactationPeriod'
}];
export var familyHistoryOptions = [{
  label: '糖尿病',
  value: Diseases.Diabetes,
  i18nKey: 'client:familyHistoryOptions.diabetes',
  members: []
}, {
  label: '高血壓',
  value: Diseases.Hypertension,
  i18nKey: 'client:familyHistoryOptions.hypertension',
  members: []
}, {
  label: '心臟病',
  value: Diseases.HeartDisease,
  i18nKey: 'client:familyHistoryOptions.heartDisease',
  members: []
}, {
  label: '痛風',
  value: Diseases.Gout,
  i18nKey: 'client:familyHistoryOptions.gout',
  members: []
}, {
  label: '高血脂',
  value: Diseases.Hyperlipidemia,
  i18nKey: 'client:familyHistoryOptions.hyperlipidemia',
  members: []
}, {
  label: '脂肪肝',
  value: Diseases.FattyLiver,
  i18nKey: 'client:familyHistoryOptions.fattyLiver',
  members: []
}, {
  label: '代謝症候群',
  value: Diseases.MetabolicSyndrome,
  i18nKey: 'client:familyHistoryOptions.metabolicSyndrome',
  members: []
}, {
  label: '子宮肌瘤',
  value: Diseases.UterineFibroids,
  i18nKey: 'client:familyHistoryOptions.uterineFibroids',
  members: []
}, {
  label: '膽結石',
  value: Diseases.Gallstones,
  i18nKey: 'client:familyHistoryOptions.gallstones',
  members: []
}, {
  label: '其他',
  value: Diseases.Others,
  i18nKey: 'client:familyHistoryOptions.others',
  members: []
}];
export var familyMemberOptions = [{
  label: '父',
  value: FamilyMember.Father,
  i18nKey: 'client:familyMemberOptions.father'
}, {
  label: '母',
  value: FamilyMember.Mother,
  i18nKey: 'client:familyMemberOptions.mother'
}, {
  label: '子',
  value: FamilyMember.Son,
  i18nKey: 'client:familyMemberOptions.son'
}, {
  label: '女',
  value: FamilyMember.Daughter,
  i18nKey: 'client:familyMemberOptions.daughter'
}, {
  label: '兄',
  value: FamilyMember.OlderBrother,
  i18nKey: 'client:familyMemberOptions.olderBrother'
}, {
  label: '弟',
  value: FamilyMember.YoungerBrother,
  i18nKey: 'client:familyMemberOptions.youngerBrother'
}, {
  label: '姐',
  value: FamilyMember.OlderSister,
  i18nKey: 'client:familyMemberOptions.olderSister'
}, {
  label: '妹',
  value: FamilyMember.YoungerSister,
  i18nKey: 'client:familyMemberOptions.youngerSister'
}, {
  label: '伯/叔',
  value: FamilyMember.Uncle,
  i18nKey: 'client:familyMemberOptions.uncle'
}, {
  label: '姑',
  value: FamilyMember.Aunt,
  i18nKey: 'client:familyMemberOptions.aunt'
}, {
  label: '舅',
  value: FamilyMember.MaternalUncle,
  i18nKey: 'client:familyMemberOptions.maternalUncle'
}, {
  label: '姨',
  value: FamilyMember.MaternalAunt,
  i18nKey: 'client:familyMemberOptions.maternalAunt'
}, {
  label: '祖父',
  value: FamilyMember.PaternalGrandfather,
  i18nKey: 'client:familyMemberOptions.paternalGrandfather'
}, {
  label: '祖母',
  value: FamilyMember.PaternalGrandmother,
  i18nKey: 'client:familyMemberOptions.paternalGrandmother'
}, {
  label: '外祖父',
  value: FamilyMember.MaternalGrandfather,
  i18nKey: 'client:familyMemberOptions.maternalGrandfather'
}, {
  label: '外祖母',
  value: FamilyMember.MaternalGrandmother,
  i18nKey: 'client:familyMemberOptions.maternalGrandmother'
}, {
  label: '曾祖父',
  value: FamilyMember.GreatPaternalGrandfather,
  i18nKey: 'client:familyMemberOptions.greatPaternalGrandfather'
}, {
  label: '曾祖母',
  value: FamilyMember.GreatPaternalGrandmother,
  i18nKey: 'client:familyMemberOptions.greatPaternalGrandmother'
}, {
  label: '外曾祖父',
  value: FamilyMember.GreatMaternalGrandfather,
  i18nKey: 'client:familyMemberOptions.greatMaternalGrandfather'
}, {
  label: '外曾祖母',
  value: FamilyMember.GreatMaternalGrandmother,
  i18nKey: 'client:familyMemberOptions.greatMaternalGrandmother'
}];